{{ value | currency: 'GBP' : undefined : format }}
